import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Protected route component that requires authentication
 * Redirects to login page if user is not authenticated
 * Preserves the intended destination for post-login redirect
 */
export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    // Store the intended destination (including query params) for post-login redirect
    const redirectTo = `${location.pathname}${location.search}`;
    return <Navigate to="/" state={{ from: redirectTo }} replace />;
  }

  return <>{children}</>;
}
